import { SaveInStorage, GetFromStorage } from '@/vessi.utils';

export default {
	isLoading: state => {
		return state.isloading;
	},
	usuario: state => {
		if( !state.username )	state.username = GetFromStorage('user');
		return state.username;
	},
	authStatus: state =>{
		return state.auth.status;
	},
	rut: state => {
		
		return state.username;
	},
	permisos: state => {
		let can = Array.isArray(state.permisos) && !!state.permisos;
		if( can )
			return state.permisos
		else
			return [];
	},
	isLoadingPermisos: state => {
		return state.isloadingPermisos;
	},
	esRepresentanteLegal: state => {
		return state.esRepresentante || false;
	},
	consultas: state =>{
		return state.consultas;
	},
	consultasCantidad: state =>{
		return state.consultas.length;
	}
}